import { Suspense } from 'react';
import { NavLink } from 'react-router-dom';

import { useSubdomain } from 'hooks/useSubdomain';

import {
  Brand,
  MicrobesBg,
  WhiteLogo,
  ButtonColors,
  LinkButton,
  ButtonSizes,
} from 'components';
import PractitionerSplashScreen from 'views/Auth/SplashScreen/PractitionerSplashScreen';

import styles from './SplashScreen.module.css';

const SplashScreen = () => {
  const { isPractitionerPortal, isLoaded } = useSubdomain();
  if (!isLoaded) return null;
  if (isPractitionerPortal) {
    return <PractitionerSplashScreen />;
  }
  return (
    <>
      <MicrobesBg />
      <Suspense fallback={<WhiteLogo />}>
        <div className={styles.logoContainer}>
          <Brand color='light' />
        </div>
      </Suspense>
      <div className={styles.splashText}>
        <h2>Take control of your lifelong health</h2>
        <p>
          Tiny Health empowers you to stop guessing what your body needs and take action so you can feel your best.
        </p>
      </div>
      <div className='w-100'>
        <LinkButton
          label='Get started'
          href='/register'
          className='mb-4 w-100 font-weight-light'
          color={ButtonColors.GREEN}
          size={ButtonSizes.M}
        />
        <div className={styles.splashText}>
          <div className='flex'>
            <span className='ml-auto'>Have an account? </span>
            <NavLink className='ml-1 mr-auto' to='/login'>
              Login
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};
export default SplashScreen;
